export const KIOSK_PREFIX = '/kiosk';
export const KIOSK_PREFIX_STORAGE_KEY = 'kiosk-prefix';
